import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/companiesRevenueTable${`?query=${string}&date=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/companiesRevenueTable`;

/**
 *
 * @param startDate YYYY-MM-DD
 */
export const URL = (date: string, tableQuery: TableQuery): RouteDefinition =>
	`${baseRoute}/companiesRevenueTable?query=${encodeURIComponent((JSON.stringify(tableQuery)))}&date=${date}`;
